<template>
  <String class="string--blue" :strLength="this.strLength">
    <Blue :brightness="channelOneBrightness"/>
    <Blue :brightness="channelTwoBrightness"/>
  </String>
</template>

<script>
  import String from './String';
  import Blue from '../Lights/Blue';

  export default {
    name: 'BlueString',
    components: {
      String,
      Blue
    },
    props: {
      channelOneBrightness: Number,
      channelTwoBrightness: Number,
      strLength: {
        type: Number,
        default: 20
      }
    }
  };
</script>

<style>

</style>
